import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseOauth from "../Datasources/DatasourceBaseOauth.jsx";


const DatasourceKleos = (props) => {

    const AuthUrl = "https://ids.kleosapp.com/KLEOSIDENTITYv4/connect/authorize" +
        "?client_id=KleosBE.RND_CLOUDCTI_uI5u" +
        "&redirect_uri=https://auth.cloudcti.nl/webapi/oauth2" +
        "&scope=openid+profile+offline_access+kleosStateful+kleosLegal+kleosLegalApiClient" +
        "&response_type=code"
    const TokenUrl = "https://ids.kleosapp.com/KLEOSIDENTITYv4/connect/token" 
    const TokenBody = "client_id=KleosBE.RND_CLOUDCTI_uI5u&client_secret=647a3453-434f-4623-9ff2-3b33c27db5b0&redirect_uri=https://auth.cloudcti.nl/webapi/oauth2&grant_type=authorization_code&code="
    const TokenBodyType = "application/x-www-form-urlencoded"
    const TokenCodeInBody = true
    const TokenCodeReplace = false
    
    return (<DatasourceBaseOauth SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} TokenUrl={TokenUrl} TokenBody={TokenBody} TokenBodyType={TokenBodyType} TokenCodeInBody={TokenCodeInBody} TokenCodeReplace={TokenCodeReplace} OnSetReady={props.OnSetReady}/>)

}

DatasourceKleos.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceKleos